import { useNavigate } from 'react-router-dom';
import { MyCookbook } from '../components/Cookbook/MyCookbook';
import { usePageTitle } from '../hooks/usePageTitle';

export const CookbookPage = () => {
  usePageTitle('My Cookbook | Meals You Love');
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return <MyCookbook onBack={handleBack} />;
};